
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"20","height":"20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#5935DD","d":"M4.85 1.504h12.299v16.991H4.85z"}}),_c('path',{attrs:{"d":"M8.263 6.775l3.74 3.246-3.74 3.246V6.775z","fill":"#E345FF"}}),_c('path',{attrs:{"fill":"#E345FF","d":"M2.244 8.872h7.451v2.256H2.244z"}})])
          )
        }
      }
    